import React, { useCallback, useEffect, useState } from 'react';
import { appState, SDKComponentProps } from '../../../../interfaces/common';
import SDKInstallation from './SDKInstallation';
import PushNotifications from './PushNotification';
import { getAccountDetails } from '../ChatApis';
import { useSelector } from 'react-redux';
import { Flex, Text } from '@pega/cosmos-react-core';
import useLocalTranslation from '../../../../hooks/useLocalTranslation';

const MobileMessaging: React.FC<SDKComponentProps> = (props: SDKComponentProps) => {
  const { platform } = props;
  const translate = useLocalTranslation();
  const { sessionId, syncConnectionId = '' } = useSelector((state: appState) => {
    return {
      sessionId: state.sessionId,
      syncConnectionId: state.chatInfo.syncConnectionId,
    };
  });
  const [accountDetails, setAccountDetails] = useState({
    iosSdkLink: '',
    androidSdkLink: '',
    accountName: '',
    sdkConnectionId: '',
    webhook: '',
    webhookHeaders: {},
  });

  const fetchSdkAccountDetails = useCallback(
    async (connectionId: string) => {
      const response = await getAccountDetails(sessionId, connectionId);
      if (response) {
        const {
          iosSdkLink,
          androidSdkLink,
          accountName,
          connectionId: sdkConnectionId,
          webhook,
          webhookHeaders,
        } = response.data;
        setAccountDetails({ iosSdkLink, androidSdkLink, accountName, sdkConnectionId, webhook, webhookHeaders });
      }
    },
    [sessionId],
  );

  useEffect(() => {
    fetchSdkAccountDetails(syncConnectionId);
  }, [syncConnectionId, fetchSdkAccountDetails]);

  const pushNotificationUpdateCallback = () => {
    fetchSdkAccountDetails(syncConnectionId);
  };
  return (
    <Flex
      container={{
        direction: 'column',
        itemGap: 2,
        alignContent: 'around',
      }}
    >
      <SDKInstallation platform={platform} />
      <Text variant="h2">{translate('sdk_push_notification')}</Text>
      <PushNotifications
        sdkConnectionId={accountDetails.sdkConnectionId}
        sdkWebhook={accountDetails?.webhook}
        sdkWebhookHeaders={accountDetails.webhookHeaders}
        pushNotificationUpdateCallback={pushNotificationUpdateCallback}
      />
    </Flex>
  );
};

export default MobileMessaging;
